import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip-group',
  templateUrl: './chip-group.component.html',
  styleUrls: ['./chip-group.component.css'],
  standalone: false
})
export class ChipGroupComponent {
  /** Group caption, e.g. "ERİŞİM" or "KİMLİK". */
  @Input() caption = '';
}
